import { useRef, useState } from 'react';
import { useLocation } from '@reach/router';
// import { urls } from 'utils/urls';
// import { config } from 'utils/config';

import {
  apiContact,
  apiSupport,
  apiDocFeedback,
  apiBugReport,
  apiDownload,
  getAPIErrorMsg,
  apiUIKitGating,
  apiPressSubscribe,
  apiAutoModeration,
  apiVideoOptin,
  apiOnboard,
  apiOrg,
} from '../utils/api';

const resetForm = (form) => {
  form.reset();
  const dropdowns = Array.from(form.elements).filter((element) => element.type === 'select-one');
  dropdowns.forEach((select) => {
    // eslint-disable-next-line no-param-reassign
    select.selectedIndex = 0;
  });
};

export const useForm = (type = 'contact', callback) => {
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const spam = useRef(false);

  const [error, setError] = useState(undefined);

  // generate hash for detecting spam submissions
  const hash = (Math.random() + 1).toString(36).substring(7);

  const formatFormData = (fd) => {
    if (type === 'contact' || type === 'auto_moderation' || type === 'video_optin') {
      const contactFd = new FormData();
      // rename real fields
      fd.forEach((value, key) => {
        if (key.includes(hash) || key === 'gotcha') {
          const newKey = key.replace(hash, '');
          contactFd.append(newKey, value);
        }
      });
      contactFd.append('page_url', location.href);
      return contactFd;
    }

    if (type !== 'support') {
      // page_url is not required for support form
      fd.append('page_url', location.href);
    }

    if (type === 'doc') {
      // merge the emoji field into the feedback field
      const feedback = fd.get('feedback');
      const quickFeedback = fd.get('quick_feedback');
      if (feedback && quickFeedback) {
        fd.set('feedback', `${feedback}\n\nHelpful: ${quickFeedback}`);
      }
    }

    // Removing to see if the BE can accept this format
    // if (type === 'onboard') {
    //   const sdks = fd.getAll('signup_sdks');
    //   const products = fd.getAll('signup_products');
    //   fd.delete('signup_sdks');
    //   fd.delete('signup_products');
    //   fd.set('signup_sdks', sdks);
    //   fd.set('signup_products', products);
    // }

    return fd;
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    spam.current = false;

    if (success) return;
    if (error) setError(undefined);

    const rawFd = new FormData(e.target);

    // Frontend "honeypot" implementation
    // check for spam fields
    rawFd.forEach((value, key) => {
      if (!key.includes('gotcha') && !key.includes(hash) && value.length > 0) {
        spam.current = true;
      }
    });

    const fd = formatFormData(rawFd);

    setLoading(true);
    try {
      let response;
      if (type === 'contact' && !spam.current) {
        // const country = fd.get('country');
        fd.delete('country');
        response = await apiContact(fd);
        // ? Commenting out unless we decide to turn CP back on
        // Sync MAU fields up with Salesforce
        // const fullName = fd.get('name').split(' ');
        // const last_name = fullName.pop();
        // const first_name = fullName.join(' ');
        // const cpData = {
        //   first_name,
        //   last_name,
        //   email: fd.get('email'),
        //   company: fd.get('company'),
        //   country,
        //   active_users__c: fd.get('mau'),
        // };
        // window.ChiliPiper.submit('getstream', 'contact-sales', {
        //   lead: cpData,
        //   map: true,
        //   dynamicRedirectLink: `${config.baseUrl}${urls.contact}success/`,
        //   onSuccess: () => {
        //     callback(response);
        //   },
        // });
      } else if (type === 'support') response = await apiSupport(fd);
      else if (type === 'doc') response = await apiDocFeedback(fd);
      else if (type === 'bug') response = await apiBugReport(fd);
      else if (type === 'download') response = await apiDownload(fd);
      else if (type === 'subscribe') response = await apiPressSubscribe(fd);
      else if (type === 'ui_kit') response = await apiUIKitGating(fd);
      else if (type === 'auto_moderation' /* && !spam.current */) response = await apiAutoModeration(fd);
      // TODO: Check on spam settings
      else if (type === 'video_optin' /* && !spam.current */) response = await apiVideoOptin(fd);
      else if (type === 'onboard') response = await apiOnboard(fd);
      else if (type === 'org') response = await apiOrg(fd);

      // TODO - Uncomment this after converting to a full response instead of just data
      // if (response) {
      if (callback) callback(response);
      setSuccess(true);
      resetForm(e.target);
      setTimeout(() => {
        setSuccess(false);
      }, 3000);
      // } else {
      //   setError('Something went wrong. Please check all fields and try again.');
      // }
    } catch (err) {
      setError(getAPIErrorMsg(err));
    }
    setLoading(false);
  };

  const clearError = (field) => {
    if (error) {
      if (field) {
        setError({ ...error, [field]: undefined });
      } else {
        setError(undefined);
      }
    }
  };

  return { submitHandler, loading, success, error, clearError, hash };
};
